import { createFileRoute } from '@tanstack/react-router'

import { TestPlanPage } from '@/components/deliverables/test-plan-page'
import { useFollowProjectClient } from '@/hooks/use-current-client'
import { RETURN_SHAPE } from '@/lib/return-to'
import { readSearch } from '@/lib/search-params'

/** #365 : le plan de recette d'un livrable, sorti du livrable sur une page à lui. */
export const Route = createFileRoute('/_app/projects/$projectRef_/recettes_/$key')({
  validateSearch: (search: Record<string, unknown>) => readSearch(RETURN_SHAPE, search),
  component: TestPlanRoutePage,
})

function TestPlanRoutePage() {
  const { projectRef, key } = Route.useParams()
  useFollowProjectClient(projectRef)
  return <TestPlanPage key={key} projectRef={projectRef} deliverableKey={key} />
}
